import { ApiConfig } from "../../Config/ApiConfig";
import { createPostDataAction } from "./CommonAction";
import { REVIEWRATINGLIST , REVIEWRAATINGDELETE } from "../../Constants/ReviewRatingConstants";


export const ReviewlistGetAction = (payload:any) => createPostDataAction(REVIEWRATINGLIST, ApiConfig?.ReviewRatingList,payload,false );
export const ReviewDeleteAction = (payload:any) => createPostDataAction(REVIEWRAATINGDELETE, ApiConfig?.ReviewRatingDelete,payload,true );